import { render } from "./BetRoom.vue?vue&type=template&id=10d9b958&scoped=true"
import script from "./BetRoom.vue?vue&type=script&lang=js"
export * from "./BetRoom.vue?vue&type=script&lang=js"

import "./BetRoom.vue?vue&type=style&index=0&id=10d9b958&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d9b958"]])

export default __exports__